import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, addSeconds, format, intervalToDuration } from "date-fns";
import Status from "../../../components/status";
import { Button, Pagination, Spin, DatePicker, Select } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import {
  getValue,
  getDate,
  formatarDuracaoCompleta,
} from "../../../services/functions";
import CountUp from "react-countup";
import { Card, Message, ViewInput } from "../../../GlobalStyles";
import { useQuery } from "../../../hooks/Location";

export default function SolicitacoesUrgente() {
  const navigate = useNavigate();
  const query = useQuery();
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [user_id, setUser_id] = useState(query.get("cliente") || "");
  const [collaborator_id, setCollaborator_id] = useState(
    query.get("tecnico") || ""
  );
  const [status, setStatus] = useState("");
  const [averageTime, setAverageTime] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [startDate, setStartDate] = useState(addDays(new Date(), -30));
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    loadingOSs();
  }, []);

  async function loadingOSs() {
    setLoading(true);
    await api
      .get(`/orders-urgente`)
      .then((response) => {
        setOrders(response.data.orders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>OSs Urgentes</h1>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={ordersTotal} />
      </Card>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          {orders.length == 0 && (
            <Message>Nenhuma Ordem de Serviço solicitada até o momento</Message>
          )}
          <div className="orders">
            {orders.map((item) => {
              return (
                <div className="order">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.urgent && (
                      <Status
                        isUrgent={true}
                        style={{
                          marginRight: 10,
                          marginBottom: 7,
                          flexFlow: "nowrap",
                        }}
                      />
                    )}
                    {item.name && (
                      <p
                        style={{ width: "100%", fontSize: 11, marginBottom: 8 }}
                      >
                        {item.name}
                      </p>
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="title">{("0000" + item.id).slice(-4)} </p>
                    <p
                      className="back"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      {item.totalServices} serviços
                    </p>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ minWidth: 250, marginRight: 50 }}>
                      <p className="title">Status</p>
                      <Status status={item.status} urgent={item.urgent} />
                    </div>
                    <div className="item">
                      <p className="title">Última atualização</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </p>
                    </div>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate("/admin/os/" + item.id);
                    }}
                  >
                    Detalhes
                  </Button>

                  {!!item.averageTime && (
                    <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                      OS concluida em{" "}
                      {formatarDuracaoCompleta(
                        intervalToDuration({
                          start: new Date(),
                          end: addSeconds(new Date(), item.averageTime),
                        })
                      )}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={ordersTotal}
          />
        </>
      )}
    </Container>
  );
}
